module.exports = __webpack_public_path__ + "img/24.2958cb05.jpg";